import { FormBuilder } from '@/components/formBuilder';
import { Box } from '@chakra-ui/react';
import { useProjectManager } from './project-manager';
export const BasicInfoV1 = (props) => {
  const { mode } = useProjectManager();

  const getTalentPoolInfo = () => {
    const talentPoolFromForm =
      props?.formRef?.current?.values?.talent_pool_id?.value;
    const talentPoolFromProject =
      props?.projectDetails?.talentPool || props?.projectDetails?.talent_pool;
    if (talentPoolFromProject && !talentPoolFromForm) {
      return talentPoolFromProject;
    }
    if (
      (talentPoolFromForm && !talentPoolFromProject) ||
      (talentPoolFromForm && talentPoolFromProject)
    ) {
      return {
        name: props?.formRef?.current?.values?.talent_pool_id?.label || '',
        id: props?.formRef?.current?.values?.talent_pool_id?.value || '',
      };
    }
    return null;
  };
  const BasicInfoConfig = [
    {
      name: 'name',
      label: 'Project name',
      type: 'input',
      isRequired: true,
      maxLength: 60,
      placeholder: 'Software Engineer in Seattle for Acme Inc',
      disabled: mode === 'view',
      // customOnChange: (value) => {
      //   props?.canCreateTheProject(value);
      // },
    },
    {
      name: 'description',
      label: 'Description',
      type: 'textArea',
      isRequired: false,
      maxLength: 255,
      placeholder: 'Enter a description ...',
      disabled: mode === 'view',
    },
    {
      name: 'talent_pool_id',
      label: 'Talent pool',
      type: 'asyncSelectWithCreate',
      useInput: true,
      placeholder: 'Name your talent pool',
      options: [getTalentPoolInfo()],
      defaultValue: getTalentPoolInfo(),
      isAppendToBody: true,
      fetchConfig: {
        httpType: 'v1',
        endPoint: '/talent_pools/search?query=',
        processResponse: (res) =>
          res?.data?.map(({ name, id }) => ({
            label: name,
            value: { label: name, value: id },
          })),
      },
      createConfig: {
        httpType: 'v1',
        method: 'post',
        endPoint: '/talent_pools',
        processResponse: (res) => ({
          label: res?.data?.name,
          value: { label: res?.data?.name, value: res?.data?.id },
        }),
      },
      createValueFromApi: true,
      isMulti: false,
      disabled: mode === 'view',
    },
  ];
  const getBasicInfoInitialValues = () => {
    const { formRef, projectDetails } = props;

    return {
      name:
        formRef?.current?.values?.name ||
        (projectDetails?.name ? projectDetails.name : '') ||
        '',
      description:
        formRef?.current?.values?.description ||
        (projectDetails?.description ? projectDetails.description : '') ||
        '',
      talent_pool_id: getTalentPoolInfo(),
    };
  };

  return (
    <Box px={props?.px ? props?.px : 'xxl'} py={props?.py ? props?.py : '12px'}>
      <FormBuilder
        config={BasicInfoConfig}
        formRef={props?.formRef}
        initialValues={getBasicInfoInitialValues()}
        isObserveEnabled={true}
        observFunc={props?.observFunc}
      />
    </Box>
  );
};
